import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

export const getPaymentSubmitButtonDataQAAttributes = (
  method: PaymentMethod | null,
) => {
  return {
    'data-qa-architecture': method?.architecture,
    'data-qa-bm-code': method?.bmCode,
    'data-qa-integration-type': method?.integrationType,
    'data-qa-psp-code': method?.pspCode,
    'data-qa': 'submit-button',
  }
}
